String.prototype.format = String.prototype.f = function () {
    var s = this,
        i = arguments.length;

    while (i--) {
        s = s.replace(new RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);
    }
    return s;
}

$(document).ready(function () {
    // Empty arrays used to hold  the dates
    var periodDays = [];
    var prePeriodDays = [];
    var peakOvulationDays = [];
    var postPeriodDays = [];
	
	$("#calsection").hide();
    
    // Global variable for smartphone detection switch. Any smartphone/desktop specific functionlity should be based on only this variable.
    // Note : User agent in conjuction with screen horizontal resolution is used to set this flag.
    var isMobileLayout = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && ($(window).width() < 767)) {
        isMobileLayout = true;
    }
	if ($(window).width() < 1023)
	{
        isMobileLayout = true;
	}
	

    // Method supplied by the plugin Jquery.UI.Custom.js is used for creating calendar and appending to the selector.
    // It is highly recommended that you go througt the api documentation at http://api.jqueryui.com/datepicker/ before modifying any methods.
    $("div#datepicker").datepicker({
        dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        dateFormat: "M. d ",
		showOtherMonths: true,
		selectOtherMonths: false,
		onSelect: function (dateText, inst) {
				var selectedDate = dateText.split(" "); 
				var suffix = "";
					switch(inst.selectedDay) {
						case '1': case '21': case '31': suffix = 'st'; break;
						case '2': case '22': suffix = 'nd'; break;
						case '3': case '23': suffix = 'rd'; break;
						default: suffix = 'th';
					}           
				var htmlString = "<span>{0} {1}</span> <span>{2}</span>".format(selectedDate[0], selectedDate[1] + suffix, selectedDate[2]);
				//$(".period-calendar-container .period-calendar-date-selection > div:first-child .display-box p").html(htmlString);
				$("#todaydate").html(htmlString);
				$("div#datepicker").hide();
//				$(".fa-calendar").removeClass("icon_active");
			}
    
    });

    // To set the current date by default, click action is triggered. 
    // It is equivalent to navigating to the current day in the calendar and clicking on it.
    $('.ui-datepicker-today').click();

    $("#selectdate").click(function (event) {
        event.stopPropagation();
//        $(this).toggleClass('icon_active');
        $("div#datepicker").toggle();
    });

    $("html").on("click", function () {
        $("div#datepicker").hide();
        $(".fa-calendar").removeClass('icon_active');
    });

    $("a.date-picker,div#datepicker").on("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
    });

 
    $(".tracknow").click(function () {
        var monthCount = isMobileLayout ? 1 : 3;

        var selectedDate = $("div#datepicker").datepicker('getDate');
        var cycleLength = parseInt($('#cycleLen').text(), 10);
        var duration = parseInt($('#duration').text(), 10);

        RenderCalendar(selectedDate, cycleLength, duration, monthCount);
		$("html, body").animate({ scrollTop: $('#calsection').offset().top }, 1000);
    });

    $('.nextPrevious .previous_result').click(function () {
        var monthCount = isMobileLayout ? -1 : -3;
        ExtendCalendar(monthCount);        
    });

    $('.nextPrevious .next_result').click(function () {
        var monthCount = isMobileLayout ? 1 : 3;
        ExtendCalendar(monthCount);
    });

    function BindMobileEvents() {
        $('.close_popup').click(function () {
            $('.period_details > div').hide();
        });

        $("#fa-calendar").click(function (event) {
            event.stopPropagation();
            $(".fa-calendar").toggleClass('icon_active');
            $("div#datepicker").toggle();
        });
    }

	$('#printit, #pdfit ').on('click', function (event) {
//		event.preventDefault();
//		event.stopPropagation();
//		$("#proslider").hide();
//		$("#topbox").hide();
		window.print();
//		$("#proslider").show();
//		$("#topbox").show();
	});

    function RenderCalendar(date, length, duration, monthCount) {

        var cycle = 0;
        var singleDay = 60 * 60 * 24 * 1000;                        // Total number of milliseconds in a day.

        var monthFirstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastMonth = new Date(date.getFullYear(), date.getMonth() + monthCount, 2);
        var nextCycleStartDate = date;
        var cycleStart = date;        

        periodDays = [];
        prePeriodDays = [];
        postPeriodDays = [];
        peakOvulationDays = [];

        // Start the cycle from One month before the visible month
        while (monthFirstDay < cycleStart) {
            cycleStart = new Date(cycleStart - length * singleDay);
        }

        while (nextCycleStartDate < lastMonth) {
            var startDate = Date.parse(cycleStart);
            nextCycleStartDate = new Date(startDate + length * singleDay);

            // Pre-Period Days
            for (var i = 1; i <= 2; i++) {
                var tempDate = startDate - i * singleDay;
                prePeriodDays.push(new Date(tempDate).toDateString());
            }

            // Period Days
            for (var i = 0; i < duration; i++) {
                var tempDate = startDate + i * singleDay;
                periodDays.push(new Date(tempDate).toDateString());
            }

            // Post-Period Days
            for (var i = 0; i < 2; i++) {
                var tempDate = startDate + (duration + i) * singleDay;
                postPeriodDays.push(new Date(tempDate).toDateString());
            }

            // Peak-Ovulation Days
            for (var i = 0; i < 5; i++) {
                var tempDate = startDate + (10 + i) * singleDay;
                peakOvulationDays.push(new Date(tempDate).toDateString());
            }

            cycleStart = nextCycleStartDate;
        }

		for (var i = 0; i < (duration * 2); i++) {
			if (i == (duration)){
				var startdate = new Date(periodDays[i]);
			}
			if (i == ((duration * 2) -1)) {
				var enddate = new Date(periodDays[i]);
			}
		}
		$('.pc-add-to-cal').empty();
		addtocal(startdate,enddate);
        CreateCalendar(date, monthCount);
    }

    function ExtendCalendar(monthCount) {

        /// <summary>
        ///     Changes the month displayed in the calendar.
        ///     Used for navigating visible months in the displayed tracker
        /// </summary>
        /// <param name="monthCount" type="int">
        ///     Number of months to be rendered.
        /// </param>

        var selectedDate = $("div#datepicker").datepicker('getDate');
        var cycleLength = parseInt($('#cycleLen').text(), 10);
        var duration = parseInt($('#duration').text(), 10);

        var singleDay = 60 * 60 * 24 * 1000;
        var lastMonth = new Date();
        var nextCycle = selectedDate;

        // monthCount will be -ve for previous months w.r.t the months displayed
        // monthCount will be +ve for upcoming months w.r.t the months displayed
        if (monthCount > 0) {
            lastMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + monthCount, 2);
            while (lastMonth > nextCycle) {
                nextCycle = new Date(Date.parse(nextCycle) + cycleLength * singleDay);
            }
        }
        else {
            lastMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + monthCount + 1, 0);
            while (lastMonth <= nextCycle) {
                nextCycle = new Date(Date.parse(nextCycle) - cycleLength * singleDay);
            }
            monthCount = -(monthCount);
        }

        // Since the RenderCalendar method always takes the start date from datepicker plugin,
        // the next cycle start date should be set before calling up the method
        $("div#datepicker").datepicker("setDate", nextCycle);
        RenderCalendar(nextCycle, cycleLength, duration, monthCount);
    };

    function CreateCalendar(initialDate, monthCount) {

        /// <summary>
        ///     Creates a calendar by invoking the datepicker method of the plugin.
        ///     The created calendar is always appended to the hardcoded jQuery selector
        /// </summary>
        /// <param name="monthCount" type="int">
        ///     Number of months to be rendered.
        /// </param>

        // Go through the api documentation.
        // Following methods should not be modified unless the user has thorough knowledge of the datepicker plugin

        $("#period_result_calender").datepicker("destroy");

        $("#period_result_calender").datepicker({
            dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
            numberOfMonths: monthCount,
            beforeShowDay: PaintCalendar,
			showOtherMonths: true,
			selectOtherMonths: false,
            defaultDate: initialDate
        });

        // Smartphone does not have clearly labeled button for navigation.
        // So the default nav buttons supplied by the datepicker is reused.
        if (isMobileLayout) {
            $("#period_result_calender .ui-corner-all").off('click');
            $("#period_result_calender .ui-datepicker-prev").on('click', function () { $('.previous_result').click(); });
            $("#period_result_calender .ui-datepicker-next").on('click', function () { $('.next_result').click(); });
        }
		else
		{
			$("#period_result_calender .ui-datepicker-prev").on('click', function () { $('.previous_result').click(); });
            $("#period_result_calender .ui-datepicker-next").on('click', function () { $('.next_result').click(); });
		}

        // Auto generated classes interrupt the functionality
        $('#period_result_calender .ui-datepicker-today').removeClass('ui-datepicker-today');
        $('#period_result_calender .ui-datepicker-current-day').removeClass('ui-datepicker-current-day');

        $('.period_legends').show();
        $('#calsection').show();
        $('.period_details div').hide();

        var eventType = "";

        if (isMobileLayout) {
            eventType = "click";
        }
        else {
            eventType = "mouseover click";
            $(".periodDays_detail").show();
        }

        // Events bound for displaying tips for the selected phase or day
        $(".period_results a").on(eventType, function (event) {
            event.preventDefault();
            event.stopPropagation();
            var detail = $("." + $(this).parent().attr("class").split(" ").pop() + "_detail");

            if (detail.length) {
                if (!isMobileLayout) {
                    // fix for scroll movement in Windows Safari
                    $(".period_details").css("height", $(detail).css("height"));
                    $(".period_details").css("margin-top", $(detail).css("margin-top"));
                }
                $(".period_details div").hide();
                $(detail).show();
            }
        });
		
    }

    function PaintCalendar(date) {

        /// <summary>
        ///     This function will be called by the datepicker on 
        ///     creation of each day for adding attributes to days.
        ///     Should not be called directly by the user.
        /// </summary>
        /// <param name="date" type="DateTime">
        ///     Then date object will be passed by the datepicker plugin.
        /// </param>

        var dateValue = date.toDateString();

        if ($.inArray(dateValue, periodDays) > -1) {
            return [true, "period-days", "Heaviest Flow"];
        } else if ($.inArray(dateValue, prePeriodDays) > -1) {
            return [true, "pre-period", "Pre-Period"];
        } else if ($.inArray(dateValue, postPeriodDays) > -1) {
            return [true, "post-period", "Post Period"];
        } else if ($.inArray(dateValue, peakOvulationDays) > -1) {
            return [true, "peak-ovulation", "Peak Ovulation"];
        }
        else {
            return [true, ""];
        }
    }

    function RenderPhases(phaseData, template) {
        if (phaseData != undefined && phaseData.length > 0) {

            var phaseRender = "";
            var legendRender = "";
            var legendTemplate = "<li><span></span><span>{0}</span></li>\n";

            for (var i = 0; i < phaseData.length; i++) {
                var item = phaseData[i];
                legendRender += legendTemplate.format(item.Legend);
                phaseRender += template.format(item.CssClass, item.Header, item.Description, item.PrintLink.Text, item.ShoppingLink.URL, item.ShoppingLink.Text);
            }

            $(".period_details").append($.parseHTML(phaseRender));
            $(".legends").append($.parseHTML("<ul>{0}</ul>".format(legendRender)));
        }
    }

    // Populates the questions as a numbered list
    function RenderQuestions(questions) {
        if (questions != undefined && questions.length > 0) {
            for (var i = 0; i < questions.length; i++) {
                var selector = ".period-calendar-date-selection > div:eq({0}) h2".format(i);
                $(selector).text(questions[i]);
                $(selector).before($.parseHTML("<span class=\"counts\">{0}.</span>\n".format(i + 1)));
            }
        }
    }

   function addtocal(startdate,enddate) {
 	    var myCalendar = createCalendar({
      options: {
        class: '',
        
        // You can pass an ID. If you don't, one will be generated for you
        id: 'my-id'
      },
      data: {
        // Event title
        title: 'Period Days',

        // Event start date
        start: new Date(startdate),
        
        // Event duration (IN MINUTES)
        duration: 120,

        // You can also choose to set an end time
        // If an end time is set, this will take precedence over duration
        end: new Date(enddate),     

        // Event Address
        address: '',

        // Event Description
        description: 'Period Days'
      }
    });

    document.querySelector('.pc-add-to-cal').appendChild(myCalendar);
}
	
});
